// @flow
import React from 'react';
import { Controller } from 'react-hook-form';
import { CombinedPreviewVideo } from '../../articles/components/CombinedPreviewVideo';
import { toUndefined } from 'fp-ts/lib/Option';
export const VideoBlock = props => {
	const { control } = props;
	return (
		<Controller
			name="config.video"
			control={control}
			rules={{ required: true }}
			render={({ field: { onChange, value } }) => (
				<CombinedPreviewVideo preview={value} edit={false} onValueChange={v => onChange(toUndefined(v))} />
			)}
		/>
	);
};



// WEBPACK FOOTER //
// src/components/configurable-blocks/parts/VideoBlock.jsx